import React from 'react';
import { Link } from 'react-router-dom';
import { appUrls } from '../../../utils/urls/appUrls';
import AuthFormWrapper from '../../layout/AuthFormWrapper';

export default function LinkVerificationSuccessComponent({formTitle, activationMessage}) {

  return (
    <AuthFormWrapper sub_text={formTitle} icon="mdi mdi-checkbox-marked-circle" iconColor="text-success">
        <div className='text-center mb-5' style={{color: '#31343D'}}>
            <p style={{lineHeight: '1.8rem'}}>{activationMessage}</p>
        </div>
      <div className="col-md-12">


        <button type="button" className="btn btn-outline-primary mb-4">
            <Link className='text-hover-white' to={appUrls.login}>Login</Link>
        </button>

      </div>
    </AuthFormWrapper>
  )
}
